<script setup lang="ts">
  defineOptions({
    name: 'AuthBrandingHeader',
  })

  import type { PropType } from 'vue'

  import CPAvatar from '@ui/components/CPAvatar.vue'

  import CPText from '@ui/components/CPText.vue'

  /**
   * Shared portal branding (logo + name). Optional `#leading` for controls (e.g. back) on the same row.
   * Full-page layouts (e.g. clientportal AuthPageLayout) compose this above auth forms; migration screens may embed it instead.
   */
  defineProps({
    showBranding: {
      type: Boolean,
      default: false,
    },
    portalLogo: {
      type: String as PropType<string | null>,
      default: null,
    },
    portalName: {
      type: String,
      default: 'ClientPortal',
    },
  })
</script>

<template>
  <div v-if="showBranding" class="mb-6 flex w-full min-w-0 items-center gap-3">
    <div v-if="$slots.leading" class="flex flex-shrink-0 items-center gap-2">
      <slot name="leading" />
    </div>
    <div class="flex min-w-0 flex-1 items-center gap-3">
      <CPAvatar :src="portalLogo || ''" :title="portalName" size="sm" class="flex-shrink-0 rounded-lg" />
      <CPText size="lg" weight="bold" class="min-w-0 truncate text-900">
        {{ portalName }}
      </CPText>
    </div>
  </div>
</template>
